import EventEmitter from 'events';
import { useEffect } from 'react';
import { func } from 'prop-types';
import { useSnackbar } from 'notistack';

const Emitter = new EventEmitter();

const ToastContextEmitter = () => {
  const { enqueueSnackbar } = useSnackbar();

  const anchorOptions = {
    vertical: 'top',
    horizontal: 'center'
  };

  useEffect(() => {
    Emitter.addListener('status_message', ({ message, type }) => {
      if (type == 'info') {
        enqueueSnackbar(message, {
          variant: 'info',
          anchorOrigin: anchorOptions
        });
      } else if (type == 'error') {
        enqueueSnackbar(message, {
          variant: 'error',
          anchorOrigin: anchorOptions
        });
      } else {
        enqueueSnackbar(message, {
          variant: 'info',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
          }
        });
      }
    });
  }, []);

  return '';
};

ToastContextEmitter.propTypes = {
  enqueueSnackbar: func
};

export const showInfoMessage = (message) => {
  Emitter.emit('status_message', {
    message,
    type: 'info'
  });
};

export const showErrorMessage = (message) => {
  Emitter.emit('status_message', {
    message,
    type: 'error'
  });
};

export const showNotification = (message) => {
  Emitter.emit('status_message', {
    message,
    type: 'notification'
  });
};

export default ToastContextEmitter;
